import React from 'react'
import { DefaultResult } from './DefaultResult'

const component = 'search'

export function Results({ results, readMoreLabel }) {
    return (
        <div className={`${component}__results`}>
            {results &&
                results.map((result) => <DefaultResult key={result.id} readMoreLabel={readMoreLabel} {...result} />)}
        </div>
    )
}
